module.exports = __webpack_public_path__ + "img/01.a67b5e8e.jpg";